export default "__VITE_ASSET__CcAVaAdX__"